import { createElement, forwardRef } from 'react';

export interface WeaveFlyoutElement extends HTMLElement {
  repositionFlyout?: () => void;
}

interface WeaveFlyoutProps extends React.HTMLAttributes<HTMLElement> {
  className?: string;
  nub?:
  "up-left" |
  "up-left-aligned" |
  "up-center" |
  "up-right" |
  "down-left" |
  "down-center" |
  "down-right" |
  "left-center" |
  "right-center" |
  "left-top" |
  "right-top";
  open?: boolean;
  hideArrow?: boolean;
  trigger?: React.ReactNode;
  defaultSlot?: React.ReactNode;
}

export const WeaveFlyout = forwardRef<WeaveFlyoutElement, WeaveFlyoutProps>(function WeaveFlyout(
  {
    className,
    nub,
    open,
    hideArrow,
    trigger,
    defaultSlot,
    children,
    ...rest
  },
  ref
) {
  return createElement(
    'weave-flyout',
    {
      className,
      nub,
      open,
      'hide-arrow': hideArrow,
      trigger,
      defaultSlot,
      ref,
      ...rest,
    },
    children
  );
});
